export class PuntoVisitaLocalizacion {

public   id: number;   
public   idPunto: string;
public   nombrePunto: string;
public   idVisita: string;
public   idCompania: string;
public  fecha: Date;
public   longitud: string;
public   latitud: string;
public  altitud: number;
public   estadoLocalizacion: string;
}

 